import { render, staticRenderFns } from "./TestimonialLogos.vue?vue&type=template&id=4e5c0faf"
import script from "./TestimonialLogos.vue?vue&type=script&lang=js"
export * from "./TestimonialLogos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports